import { Runtime } from "@/components/common";

export default function SpecialTitleAndRuntime({
  title,
  runtime,
  isLivestream,
}: {
  title: string;
  runtime: number;
  isLivestream: boolean;
}) {
  return (
    <>
      <h3 className="font-sans text-xl font-semibold normal-case text-slate-gray-900 md:text-2xl line-clamp-3 group-hover:underline underline-offset-2 decoration-2">
        {title}
      </h3>
      {isLivestream ? (
        <span className="flex items-center text-sm mt-1.5 text-slate-gray-900 line-clamp-2">
          Live stream
        </span>
      ) : (
        <Runtime
          runtime={runtime}
          className="flex items-center text-sm mt-1.5 text-slate-gray-900 line-clamp-2"
        />
      )}
    </>
  );
}
